/* eslint-disable */

import React from 'react';
import {
  DNABox,
  DNAText,
} from '@alucio/lux-ui'
import { DeviceMode, useAppSettings } from 'src/state/context/AppSettings';
import { PlaygroundAiSearch } from './Playground/aiSearch/aiSearch';



const PlaygroundDesktop = () => {
  return (
    <PlaygroundAiSearch />
  )
}

const PlaygroundTablet = () => {
  return (
    <PlaygroundAiSearch />
  )
}

type DeviceModeVariants = Record<DeviceMode, React.ElementType>

const deviceModeVariants:DeviceModeVariants = {
  desktop: PlaygroundDesktop,
  tablet: PlaygroundTablet,
}

export default () => {
  const { deviceMode } = useAppSettings()

  const CurrentDeviceModeVariant = deviceModeVariants[deviceMode]

  return <CurrentDeviceModeVariant />
}
